'use client';

import { createContext } from 'react';
import type { ToastOptions } from './ToastTypes';

/**
 * When initializing the toast item context, the default duration is set to `null`
 */
const defaultContext: Required<Pick<ToastOptions, 'duration'>> = {
  duration: null,
};

export const ToastItemContext = createContext(defaultContext);
